/**
 * Endereco
 * @author Simpli CLI generator
 */
import {
  $,
  ObjectCollection,
  HttpBody,
  ID,
  RequestExclude,
  Resource,
  IResource,
  Resp,
} from 'simpli-web-sdk'
import {
  ValidationCEP,
  ValidationMaxLength,
  ValidationRequired,
} from 'simpli-web-sdk'
import EnderecoSchema from '@/schema/Endereco.schema'
import {UFInitial} from '@/enums/UFInitial'
import * as Helper from '@/helpers'

export default class Endereco extends Resource {

  get $schema() {
    return EnderecoSchema(this)
  }

  get $id() {
    return this.idEnderecoPk
  }
  set $id(val: ID) {
    this.idEnderecoPk = val
  }

  get ufResource() {
    return this.allUF.get(this.uf)
  }
  set ufResource(val: IResource | null) {
    this.uf = (val && (val.$id as UFInitial)) || null
  }

  static stringified(endereco: Endereco): string {
    const {logradouro, nro, cep, cidade, uf} = endereco
    let address = ''

    if (logradouro && logradouro !== 'null') {
      address += `${logradouro}`
    }
    if (nro && nro !== 'null') {
      address += `, ${nro}`
    }
    if (cep && cep !== 'null') {
      address += ` - ${cep}`
    }
    if (cidade && cidade !== 'null') {
      address += ` / ${cidade}`
    }
    if (uf && uf.toString() !== 'null') {
      address += ` - ${uf}`
    }

    return address
  }
  readonly $name: string = 'Endereco'

  readonly $endpoint: string = '/user/endereco{/id}'

  idEnderecoPk: ID = 0

  @ValidationRequired()
  @ValidationMaxLength(255)
  logradouro: string = ''

  @ValidationMaxLength(127)
  nro: string = ''

  @ValidationMaxLength(255)
  bairro: string = ''

  @ValidationRequired()
  @ValidationMaxLength(255)
  @ValidationCEP()
  cep: string = ''

  @ValidationRequired()
  @ValidationMaxLength(255)
  cidade: string = ''

  @ValidationRequired()
  uf: UFInitial | null = null

  latitude: number | null = null

  longitude: number | null = null

  @ValidationMaxLength(255)
  complemento: string = ''

  @ValidationMaxLength(255)
  pais: string = ''

  @RequestExclude()
  allUF = new ObjectCollection(UFInitial)

  toString(): string {
    const {logradouro, nro, cep, cidade, uf, complemento} = this
    let address = ''

    if (logradouro && logradouro !== 'null') {
      address += `${logradouro}`

      if (nro && nro !== 'null') {
        address += `, ${nro}`
      }
    }

    if (cidade && cidade !== 'null') {
      address += ` / ${cidade}`
    }
    if (uf && uf.toString() !== 'null') {
      address += ` - ${uf}`
    }
    if (complemento && complemento.toString() !== 'null') {
      address += ` / ${complemento}`
    }

    return address
  }

  logradouroCidadeUf(): string {
    const {logradouro, cidade, uf} = this
    let address = ''

    if (logradouro && logradouro !== 'null') {
      address += `${logradouro}`
    }
    if (cidade && cidade !== 'null') {
      address += ` / ${cidade}`
    }
    if (uf && uf.toString() !== 'null') {
      address += ` - ${uf}`
    }

    return address
  }

  async populateFromCEP(
    spinner = 'populateFromCEP',
  ): Promise<Resp<ViaCepResp> | null> {
    if (this.cep === undefined || this.cep.length !== 8) {
      return null
    }

    const fetch = async () => {
      const resp = await new HttpBody<ViaCepResp>(Object as any).GET(
        `//viacep.com.br/ws/${this.cep}/json/`,
        {},
        false,
      )
      const data = resp.data

      this.logradouro = data.logradouro || ''
      this.cidade = data.localidade || ''
      this.bairro = data.bairro || ''
      this.uf = (data.uf || '') as UFInitial

      return resp
    }

    return await $.await.run(fetch, spinner)
  }

  async populateLatLng(spinner = 'populateLatLng'): Promise<Resp<any> | null> {
    if (!this.toString()) {
      return Promise.resolve(null)
    }

    const params = {
      q: this.toString(),
      limit: 1,
      format: 'json',
    }

    const getResp = (queryParams: any) =>
      new HttpBody<any>(Object).GET(
        `https://nominatim.openstreetmap.org/search/`,
        {params: queryParams},
        false,
      )

    const fetch = async () => {
      let resp = await getResp(params)

      if (!resp.data.length) {
        // Try again using regex
        const address = this.clone()
        const match = address.logradouro.match(/^.+\d/g)
        if (match && match[0]) {
          address.logradouro = match[0]
          params.q = address.toString()
          resp = await getResp(params)
        }
      }

      const data = resp.data

      if (data && data.length) {
        const lat = data[0].lat
        const lng = data[0].lon

        this.latitude = lat
        this.longitude = lng
        return resp
      }

      return resp
    }

    return await $.await.run(fetch, spinner)
  }

  async persistEndereco(model?: Endereco, spinner = 'persistEndereco') {
    const fetch = async () => {
      if (model) await model.validate()
      return await this.POST(`/user/endereco`, model)
    }

    return await $.await.run(fetch, spinner)
  }

  async getEndereco(id: number, spinner = 'getEndereco') {
    const fetch = async () => await this.GET(`/user/endereco/${id}`)
    return await $.await.run(fetch, spinner)
  }

  hasFilledAnyInput() {
    return (this.cep ||
        this.nro ||
        this.logradouro  ||
        this.cidade ||
        this.pais ||
        this.bairro ||
        this.complemento
    )
  }
}

export interface ViaCepResp {
  bairro: string
  cep: string
  complemento: string
  gia: string
  ibge: string
  localidade: string
  logradouro: string
  uf: string
  unidade: string

  erro: string
}
